import { gql } from '@apollo/client';
import { Schema } from './schema';

export type QueryVariables = {
  attributes: RequestIncome;
};

type RequestIncome = {
  mainJobIncome?: string;
  sideJobIncome?: string;
  businessIncome?: string;
  businessExpense?: string;
  miscellaneousIncomeOfficalPension?: string;
  miscellaneousIncomeOther?: string;
  miscellaneousExpense?: string;
  dividendIncome?: string;
  dividendExpense?: string;
  realEstateIncome?: string;
  realEstateExpense?: string;
  retirementIncome?: string;
  lengthOfService?: string;
  retireForDisablity?: boolean;
  isOfficerRetirementAllowance?: boolean;
  otherIncome?: string;
  otherExpense?: string;
  otherExpenseSpecialDeduction?: string;
  otherEarings?: string;
};

export const convertFormDataToQueryVariables = (data: Schema): QueryVariables => {
  const variables: QueryVariables = {
    attributes: {
      mainJobIncome: data.mainJobIncome || '0',
      sideJobIncome: data.sideJobIncome || '0',
      businessIncome: data.businessIncome || '0',
      businessExpense: data.businessExpense || '0',
      miscellaneousIncomeOfficalPension: data.miscellaneousIncomeOfficalPension || '0',
      miscellaneousIncomeOther: data.miscellaneousIncomeOther || '0',
      miscellaneousExpense: data.miscellaneousExpense || '0',
      dividendIncome: data.dividendIncome || '0',
      dividendExpense: data.dividendExpense || '0',
      realEstateIncome: data.realEstateIncome || '0',
      realEstateExpense: data.realEstateExpense || '0',
      retirementIncome: data.retirementIncome || '0',
      lengthOfService: data.lengthOfService,
      retireForDisablity: data.retireForDisablity,
      isOfficerRetirementAllowance: data.isOfficerRetirementAllowance,
      otherIncome: data.otherIncome || '0',
      otherExpense: data.otherExpense || '0',
      otherExpenseSpecialDeduction: data.otherExpenseSpecialDeduction || '0',
      otherEarings: data.otherEarings || '0'
    }
  };

  return variables;
};

export const INCOME_FRAGMENT = gql`
  fragment Income on Income {
    id
    salaryIncome
    businessIncome
    businessExpense
    miscellaneousIncomeOfficalPension
    miscellaneousIncomeOther
    miscellaneousExpense
    dividendIncome
    dividendExpense
    realEstateIncome
    realEstateExpense
    retirementIncome
    lengthOfService
    retireForDisablity
    isOfficerRetirementAllowance
    otherIncome
    otherExpense
    otherExpenseSpecialDeduction
    otherEarings
    mainJobIncome
    sideJobIncome
    hasSideJob
  }
`;

export const ANSWER_ALL_INCOME = gql`
  mutation answerAllIncome($attributes: AnswerAllIncomeAttributes!) {
    answerAllIncome(input: { attributes: $attributes }) {
      questions {
        id
        status
      }
      profile {
        id
        birthday
        income {
          ...Income
          hasBusinessIncome
          hasMiscellaneousIncome
          hasDividendIncome
          hasRealEstateIncome
          hasRetirementIncome
          hasOtherIncome
        }
      }
    }
  }
  ${INCOME_FRAGMENT}
`;
